import React, {Component, createRef} from "react";
import { contactName } from "../../helpers/ContactName";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import MainHelper from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
class ApproachingReceivablesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleReceivableDetail = (receiveId) => {
        this.props.history.push(`/receivable-detail/${receiveId}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewReceivablePermission = userPermissions.includes('view receivable');
        const columns = [
            {
                name: 'ID',
                selector: row => row.receivable_id,
                sortable: true
            },
            {
                name: 'Fatura No',
                selector: row => row.e_invoice_id || row.invoice_no || "Fatura bulunamadı", // Eğer `approachingDebts` veri kümesinde bu alanlar varsa
                sortable: true
            },
            {
                name: 'Müşteri',
                selector: row => contactName(row).toLocaleUpperCase("tr-TR"),
                sortable: true
            },
            {
                name: 'Son Ödeme Tarihi',
                selector: row => MainHelper.dateFormat(row.due_date).split(' 0')[0]
            },
            {
                name: 'Toplam Tutar',
                selector: row => row.total_amount
            },
            {
                name: 'Kalan Tutar',
                selector: row => row.remaining_amount
            },



        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/reports/approaching-receivables"}
                columns={columns}
                onRowClicked={userHasViewReceivablePermission ? row => this.handleReceivableDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(ApproachingReceivablesTable));
